import React from 'react';
import SubHeader from '../SubHeader';
import { useTranslation } from '../../../../../../hooks';
import { useWeb3 } from '../../../../../../hooks/useWeb3';
import { OperationButton as ConnectButton } from '../SignOperationCell';
import CopyableText from '../../../../../../components/CopyableText';

interface IProps {
  multiSigRawTxs: any[];
  web3: ReturnType<typeof useWeb3>;
}

const CurrentSignAddressBar = (props: IProps) => {
  const { multiSigRawTxs, web3 } = props;
  const { account, connect } = web3;

  const { t, tc } = useTranslation('transactionRequest');
  // const signerAddresses = multiSigRawTxs?.[0]?.multi_sig_raw_tx.signer_addresses || [];
  // const { account, connect } = useWeb3({ allowedSignerAddresses: signerAddresses });

  const handleConnect = () => {
    connect();
  };

  return (
    <SubHeader
      title={t('currentSignAddress')}
      content={
        account ? (
          <CopyableText text={account} />
        ) : (
          <ConnectButton onClick={handleConnect} title={tc('connect')} />
        )
      }
      contentOnNewLine
    />
  );
};

export default CurrentSignAddressBar;
